import type { IconType } from 'react-icons';
import {
  FiBookOpen,
  FiThermometer,
  FiRepeat,
  FiSettings,
  FiBarChart2,
  FiMapPin,
  FiCamera,
  FiMail,
  FiFilter,
  FiTag,
  FiUserPlus,
  FiMoon,
  FiLink,
  FiFilm,
  FiCalendar,
  FiFolder,
  FiFile,
  FiCheckSquare,
} from 'react-icons/fi';

export type WhatsNewFeature = {
  icon: IconType;
  title: string;
  description: string;
};

export type WhatsNewEntry = {
  version: string;
  title: string;
  features: WhatsNewFeature[];
};

export const WHATS_NEW: WhatsNewEntry[] = [
  {
    version: '1.28.0',
    title: "What's new on the web",
    features: [
      {
        icon: FiThermometer,
        title: 'Smarter Temp Check',
        description:
          'Temp Check now reads your recent conversation so tone scores and suggested rewrites fit the moment.',
      },
      {
        icon: FiFilter,
        title: 'Filter expenses',
        description:
          'Narrow your list by category, date range, amount, or paid status so the transactions you care about surface first.',
      },
      {
        icon: FiTag,
        title: 'Journal tags & filters',
        description:
          'Create color-coded tags, manage them from any entry, and filter your journal by tag, type, or date.',
      },
      {
        icon: FiUserPlus,
        title: 'Invite a professional',
        description:
          'Invite your lawyer, mediator, or coach with read-only access to selected Harbor records from Settings.',
      },
      {
        icon: FiCalendar,
        title: 'Calendar sync',
        description:
          'Subscribe to your custody schedule in Google Calendar, Apple Calendar, or Outlook with a copyable feed URL.',
      },
      {
        icon: FiLink,
        title: 'Smarter chat messages',
        description:
          'Links in messages are tappable, and you can copy message text with the copy button on hover.',
      },
      {
        icon: FiFile,
        title: 'PDF expense attachments',
        description:
          'Attach PDF receipts or statements when recording an expense, then open them from the detail screen.',
      },
      {
        icon: FiMoon,
        title: 'Calm filter',
        description:
          'Set quiet hours for chat push notifications from Settings → Chat.',
      },
      {
        icon: FiFolder,
        title: 'Vault categories',
        description:
          'Organize vault files by category and filter the list to find documents faster.',
      },
      {
        icon: FiFilm,
        title: 'Videos in chat',
        description: 'Attach video files in conversations and play them inline in the thread.',
      },
      {
        icon: FiCheckSquare,
        title: 'Get started checklist',
        description:
          'A guided checklist on Expenses helps you set up children, custody, and more.',
      },
    ],
  },
  {
    version: '1.27.0',
    title: "What's new on the web",
    features: [
      {
        icon: FiBookOpen,
        title: 'Journal',
        description:
          'A private timeline for notes and phone calls; only you can see it. Open Journal from the sidebar or bottom nav.',
      },
      {
        icon: FiBarChart2,
        title: 'Exchange logging & history',
        description:
          'Log pickups and drop-offs from the calendar, then review stats and a full timeline under Exchange history.',
      },
      {
        icon: FiMapPin,
        title: 'GPS check-ins',
        description:
          'Record your location at exchanges using your browser’s location permission. List and manage check-ins anytime.',
      },
      {
        icon: FiCamera,
        title: 'Receipt scanner',
        description:
          'When you attach a receipt photo to a new expense, we read amount, merchant, category, and date to pre-fill the form.',
      },
      {
        icon: FiMail,
        title: 'Richer email exports',
        description:
          'In Settings → Export, choose date range plus journal, check-ins, and exchange compliance, alongside messages, accounting, and calendar.',
      },
    ],
  },
  {
    version: '1.22.0',
    title: "What's New in Harbor",
    features: [
      {
        icon: FiThermometer,
        title: 'Temp Check',
        description:
          'Messages are analyzed in real time as you type, helping you keep conversations calm and constructive.',
      },
      {
        icon: FiRepeat,
        title: 'Suggested Rewrites',
        description:
          'When a message sounds heated, Temp Check offers a calmer alternative you can use with one tap.',
      },
      {
        icon: FiSettings,
        title: "You're in Control",
        description: 'Turn Temp Check on or off anytime from Settings.',
      },
    ],
  },
];
